import { useQuery } from "react-query";
import { searchOfficeSettings } from "../../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useGetAllSPLCOffices = () => {
  return useQuery(
    ["GetAllSPLCOffices", { isSPLCOffices: true }],
    searchOfficeSettings,
    {
      refetchOnWindowFocus: false,
    }
  );
};
export default useGetAllSPLCOffices;
